module.exports = __webpack_public_path__ + "static/media/potato.f9fb54f0.jpg";